import { render } from "./DoctorOrderForm.vue?vue&type=template&id=6a32cc1a&scoped=true"
import script from "./DoctorOrderForm.vue?vue&type=script&lang=js"
export * from "./DoctorOrderForm.vue?vue&type=script&lang=js"

import "./DoctorOrderForm.vue?vue&type=style&index=0&id=6a32cc1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a32cc1a"]])

export default __exports__